import React, { useEffect, useState } from "react";
import * as categoryApi from "../../../apis/categoryApi";
import { Table, Card, CardBody, CardTitle, Row, Col, Button, Input, InputGroup } from "reactstrap";
import { Link, useHistory } from "react-router-dom";
import { PropTypes } from "prop-types";
import { withRouter } from "react-router-dom";
import { useSelector } from "react-redux";
import ConfirmDelete from "components/Common/ConfirmDelete";
import ConfirmRestore from "components/Common/ConfirmRestore";
import "flatpickr/dist/themes/material_blue.css"
import CategoryMenuTableItem from "components/TableItem/CategoryMenuTableItem";
import MetaTags from 'react-meta-tags';


function ListCategoryMenu(props) {
  const [deleteId, setDeleteId] = useState(null);
  const [restoreId, setRestoreId] = useState(null);
  const selectedShop = useSelector(state => state.SelectedShop);
  const [dataCategory, setDataCategory] = useState([])
  let history = useHistory();
  const showProductCatItem = () => {
    if (dataCategory) {
      if (dataCategory.length === 0) {
        return <tr></tr>;
      } else {
        return dataCategory && dataCategory.map((v, i) => {
          return (
            <CategoryMenuTableItem
              key={i}
              data={v}
              count={i + 1}
              deleteCallback={setDeleteId}
              restoreCallback={setRestoreId}
            />
          );
        });
      }
    }
  };

  const onChangePage = page => {
    let url = props.location.pathname + "?page=" + page;
    history.push(url);
  };
  useEffect(() => {
    if (! selectedShop) return;
    fetchData();
  }, [])
  const fetchData = page => {
    categoryApi.getWebCategories({'company_id': selectedShop}, fetchDataSuccess, fetchDataFail);
  };
  const fetchDataSuccess = res => {
    const { data } = res.data;
    setDataCategory(data)
  };
  const fetchDataFail = res => {
    alert("Không có dữ liệu");
  };


  const onDelete = id => {
  };
  const deleteSuccess = res => {
    setDeleteId(null);
    alert("Banner đã xoá thành công");
    handleSearch();
  };
  const deleteFail = res => {
    alert(res.message);
    setDeleteId(null);
  };

  return (
    <div className="page-content">
      <MetaTags>
          <title>CMS | Menu danh mục</title>
      </MetaTags>
      {deleteId ? (
        <ConfirmDelete
          confirmCallback={() => {
            onDelete(deleteId);
          }}
          cancelCallback={() => {
            setDeleteId(null);
          }}
        />
      ) : (
        ""
      )}
      {restoreId ? (
        <ConfirmRestore
          confirmCallback={() => {
            onRestore(restoreId);
          }}
          cancelCallback={() => {
            setRestoreId(null);
          }}
        />
      ) : (
        ""
      )}
      <Card>
        <CardBody>
          <Card color='light'>
            <CardBody>
              <Row className="justify-content-between">
              <CardTitle className="h4">Danh sách danh mục sản phẩm</CardTitle>
              </Row>
            </CardBody>
          </Card>
          <div className="table-responsive">
            <Table className="table mb-3 mytable">
              <thead>
                <tr>
                  <th>STT</th>
                  <th>Tên danh mục</th>
                  <th>Ảnh</th>
                  <th>Thứ tự hiển thị</th>
                  <th>Thao tác</th>
                </tr>
              </thead>
              <tbody>{showProductCatItem()}</tbody>
            </Table>
          </div>
          {/* <MyPagination
            startPage={dataCategory.current_page ? dataCategory.current_page : 1}
            totalItemsCount={dataCategory.total ? dataCategory.total : 5}
            callback={onChangePage}
          /> */}
        </CardBody>
      </Card>
    </div>
  );
}
ListCategoryMenu.propTypes = {
  location: PropTypes.object,
};

export default withRouter(ListCategoryMenu);
